// Primary
export const primaryBlue = "#4D81E7";
export const secondeBlue = "#d0e7FE";

// Alerts
export const success = "#00c851";
export const warning = "#ffbb33";
export const fail = "#ff4444";

// lightMode
export const bg = "#ffffff";
export const secondaryBg = "#f4f4f4";
export const textColor = "#333333";

// MainColors
export const primaryGreen = "#075B4A";
export const secondeGreen = "#348475";
export const thirdGreen = "#A7EADD";
